import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Kulturminne from './Kulturminne.jsx'
import KulturminneIcon from '../../../images/Kulturminne.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class KulturminneList extends Component {
    state = {
        kulturminner: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getKulturminner = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/kulturminne`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                kulturminner: [...this.state.kulturminner, ...data.kulturminner],
                isLoading: false,
                continuationToken: data.nextContinuationToken                
            })
        })
      }


      toggleKulturminner = () => {
        if (this.props.antall == 0) return

        if (this.state.kulturminner.length == 0) {
            this.getKulturminner()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallKulturminner = this.state.continuationToken ? `${this.state.kulturminner.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleKulturminner}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={KulturminneIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('kulturminner')} ({antallKulturminner})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.kulturminner.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.kulturminner.map((k, index) => {return (<Kulturminne key={k.kulturminneId} kulturminne={k} antall={this.props.antall} isLast={index==this.state.kulturminner.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getKulturminner}>
                                <span>{t('hent.kulturminner')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(KulturminneList)